module.exports = __webpack_public_path__ + "static/p11-055a6a0c8b46203839ff6e5fe08de49b.png";